import { faStar, faStarHalfAlt } from '@fortawesome/pro-solid-svg-icons';

import { Icon } from './icon.component';

interface StarProps {
  rating: number;
  dataTestId?: string;
}

function HalfStar() {
  return (
    <div className="relative ">
      <Icon icon={faStar} className="text-gray-200 text-sm -z-20" />

      <span className="overflow-hidden w-[8px] inline-block  z-0 absolute top-[2.9px] left-0 text-sm">
        <Icon icon={faStarHalfAlt} className="text-warning-400" />
      </span>
    </div>
  );
}

export function Star({ rating, dataTestId }: StarProps) {
  const fullStars = Number.isInteger(rating) ? rating : Math.floor(rating);
  const hasHalfStar = rating % 1 !== 0;
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

  return (
    <div className="flex items-center gap-1" data-testid={dataTestId}>
      {Array.from({ length: fullStars }).map((_, index) => {
        return <Icon key={index} icon={faStar} className="text-warning-400 text-sm" />;
      })}

      {hasHalfStar && <HalfStar />}
      {Array.from({ length: emptyStars }).map((_, index) => {
        return <Icon key={index} icon={faStar} className="text-gray-200 text-sm" />;
      })}
    </div>
  );
}
